import Resource from "./resource";

export class SystemInfoResource extends Resource {
    Version: string;
    OSVersion: string;
    WorkingSetBytes: number;
    ClrVersion: string;
    ThreadCount: number;
    Uptime: string;
}

export default SystemInfoResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/systemInfoResource.ts